import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { PackagingFormatDeleteCard } from './components/PackagingFormatDeleteCard';
import { PackagingFormatDetailsCard } from './components/PackagingFormatDetailsCard';

export function PackagingFormatDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const packagingFormatQueryResults = useQuery({
        queryKey: ['packagingFormat', id],
        queryFn: () =>
            Api.Servings.PackagingFormat.getPackagingFormat(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={packagingFormatQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <PackagingFormatDetailsCard
                                packagingFormat={data}
                            />
                            <Can I="delete" a="Product">
                                <PackagingFormatDeleteCard
                                    packagingFormat={data}
                                />
                            </Can>
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
